<script lang="ts" setup>
import Modal from "~/components/ui/modals/Modal.vue";
import useSearchStore from "~/shared/store/modules/search";
import type {IProductInfo} from "~/shared/interfaces/search/product";
import RememberMeForm from "~/features/search/RememberMeForm.vue";

defineProps<{
  product: IProductInfo
}>()

const emits = defineEmits(['close-modal'])
const searchStore = useSearchStore()

function closeModal() {
  emits('close-modal')
}
</script>

<template>
  <Modal
    :modal-is-open="searchStore.isRememberMeModal"
    modal-title="Сообщить о поступлении"
    @close-modal="closeModal"
  >
    <div class="remember-me">
      <p class="remember-me__txt">Оставьте свой email и мы оповестим вас, когда товар снова появится в наличии</p>
    </div>
    <RememberMeForm :product="product"/>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal-content__wrapper) {
  max-width: 352px;
  width: 100%;
  @include xs-breakpoint {
    max-width: none;
  }
}
.remember-me {
  &__txt {
    margin-top: 12px;
  }
}
.form {
  margin-top: 16px;
}
</style>
